export const initialState = {
	prevSaveGroupMeta: {}, // mapped by key `${lineOrProjectId}~${surveyGuid}`
	currGroupMeta: {}, // mapped by key `${lineOrProjectId}~${surveyGuid}`
	currGroupMetaStatusChanges: {}, // mapped by key `${lineOrProjectId}~${surveyGuid}`
	currReportState: {}, // mapped by key `${lineOrProjectId}~${surveyGuid}`
};

export default { initialState };
